import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import {
  $d11Parking,
  $d11Switches,
  $isPreset,
} from '../../../models/rbpLiteModel/index.js';
import { changeLayerVisibility, changePointerOnLayer } from '../../../utils/mapbox-utils.js';
import { $isDarkTheme } from '../../../models/authModel/index.js';

const onClick = (e) => {
  const feature = e.features[0];
  const coordinates = feature.geometry.coordinates.slice();
  const html = `
            <div class="popup_content_wrapper">
              <div class="popup_item_wrapper popup_item_even">
                <div class="popup_item_field">Количество мест:</div> 
                <div class="popup_item_value">${
                  feature.properties.parking_cnt || '-'
                }</div>
              </div>
            </div>`;

  new mapboxgl.Popup().setLngLat(coordinates).setHTML(html).addTo(window.map);
};

function LiteParking() {
  const mapLoaded = useUnit($mapLoaded);
  const d11Switches = useUnit($d11Switches);
  const isPreset = useUnit($isPreset);
  const d11Parking = useUnit($d11Parking);
  const isDark = useUnit($isDarkTheme);

  const createLayer = (update) => {
    const parkingData = {
      type: 'FeatureCollection',
      features: d11Parking,
    };

    if (update) {
      window.map.getSource('lite_parking_source').setData(parkingData);
    } else {
      if (!window.map.getSource('lite_parking_source')) {
        window.map.addSource('lite_parking_source', {
          type: 'geojson',
          data: parkingData,
        });
      }

      if (!window.map.getLayer('lite_parking_layer')) {
        window.map.addLayer({
          id: 'lite_parking_bg_layer',
          type: 'circle',
          source: 'lite_parking_source',
          paint: {
            'circle-color': 'white',
            'circle-radius': [
              'case',
              ['<', ['get', 'parking_cnt'], 50],
              11,
              ['<', ['get', 'parking_cnt'], 75],
              13,
              ['<', ['get', 'parking_cnt'], 110],
              16,
              11,
            ],
          },
        });

        window.map.addLayer({
          id: 'lite_parking_layer',
          type: 'symbol',
          source: 'lite_parking_source',
          layout: {
            'icon-allow-overlap': true,
            'icon-size': [
              'case',
              ['<', ['get', 'parking_cnt'], 50],
              2,
              ['<', ['get', 'parking_cnt'], 75],
              2.5,
              ['<', ['get', 'parking_cnt'], 110],
              3,
              2,
            ],
            'icon-image': 'public_parking',
          },
        });
        window.map.addLayer({
          id: 'lite_parking_label_layer',
          type: 'symbol',
          source: 'lite_parking_source',
          layout: {
            'text-field': ['get', 'parking_cnt'],
            'text-offset': [1, -1],
          },
          paint: {
            'text-color': isDark ? '#fff' : '#000',
          },
        });
      }

      window.map.on('click', 'lite_parking_layer', onClick);
      changePointerOnLayer('lite_parking_layer', true);

      changeLayerVisibility('lite_parking_layer', false);
      changeLayerVisibility('lite_parking_label_layer', false);
      changeLayerVisibility('lite_parking_bg_layer', false);

      setTimeout(() => {
        window.map.moveLayer('lite_hexagons_layer', 'lite_stops_bg_layer');
        window.map.moveLayer('lite_hexagons_layer', 'lite_parking_bg_layer');
      }, 500);
    }
  };

  useEffect(() => {
    if (mapLoaded && d11Parking.length > 0) {
      if (window.map.getLayer('lite_parking_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, d11Parking]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('lite_parking_layer')) {
      if (isPreset) {
        if (d11Switches.parking) {
          changeLayerVisibility('lite_parking_layer', true);
          changeLayerVisibility('lite_parking_label_layer', true);
          changeLayerVisibility('lite_parking_bg_layer', true);
        } else {
          changeLayerVisibility('lite_parking_layer', false);
          changeLayerVisibility('lite_parking_label_layer', false);
          changeLayerVisibility('lite_parking_bg_layer', false);
        }
      } else {
        changeLayerVisibility('lite_parking_layer', false);
        changeLayerVisibility('lite_parking_label_layer', false);
        changeLayerVisibility('lite_parking_bg_layer', false);
      }
    }
  }, [mapLoaded, isPreset, d11Switches]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('lite_parking_label_layer')) {
      if (isDark) {
        window.map.setPaintProperty(
          'lite_parking_label_layer',
          'text-color',
          '#fff'
        );
      } else {
        window.map.setPaintProperty(
          'lite_parking_label_layer',
          'text-color',
          '#000'
        );
      }
    }
  }, [isDark, mapLoaded]);

  return null;
}

export default LiteParking;
